/* Find Deals screen */
import React, { useState, useEffect, Suspense } from "react";
import { MDBBtn, MDBModal, MDBModalBody } from "mdbreact";
import axios from "../../axios";
import Footer from "../../components/Common/Footer";
import brandsData from "../../brands/common/brands.json";
import queryString from "query-string";
let CheckOutComponent;
// eslint-disable-next-line no-unused-vars
let Logo;
// eslint-disable-next-line no-unused-vars
let BrandName;
brandsData.forEach(
    ({
        name,
        url,
        component_directory_name,
        brand_directory_name,
        main_logo,
    }) => {
        if (url.includes(window.location.hostname)) {
            /* eslint-disable no-unused-expressions */
            // import("../../brands/" + brand_directory_name + "/css/style.scss");
            CheckOutComponent = React.lazy(() =>
                import(
                    "../../brands/" +
                        component_directory_name +
                        "/components/UpdateAccount/CheckOut"
                )
            );
            Logo = "/" + brand_directory_name + "/" + main_logo;
            BrandName = name;
        }
    }
);
export default function App(props) {
    const success = queryString.parse(window.location.search);
    const [clientSecret, setClientSecret] = useState("");
    const [stripePromise, setStripePromise] = useState("");
    const [state, setState] = useState({
        modalBillingDetails: false,
    });
    useEffect(() => {
        // Process URL parameters for session storage
        const urlParams = new URLSearchParams(window.location.search);
        console.log(urlParams.get('linkingUri'));
        const linkingUri = urlParams.get('linkingUri');
        if (linkingUri) {
            sessionStorage.setItem("linkingUri", linkingUri);
        }
        setSessionStorage();
        let BillingCycleRecurrence;
        !sessionStorage.getItem("daysofservice")
            ? (BillingCycleRecurrence = 0)
            : (BillingCycleRecurrence =
                  sessionStorage.getItem("daysofservice"));
        let data;
        if (!sessionStorage.getItem("newServicePlanID")) {
            data = {
                UnitID_internal: sessionStorage.getItem(
                    "unitID_internalSubscriber"
                ),
                StripeClientSecret: sessionStorage.getItem(
                    "stripeClientSecretSubscriber"
                ),
                EmailAddress: sessionStorage.getItem("emailSubscriber"),
                VenueID: sessionStorage.getItem("venueIDSubscriber"),
                "StartDateTimeUTC.ISO8601": new Date(
                    sessionStorage.getItem("dateStart")
                ).toISOString(),
                locale: "en-us",
                BillingCycleRecurrence: BillingCycleRecurrence,
                updatePaymentMethod: true,
            };
        } else {
            data = {
                ServicePlanID: sessionStorage.getItem("newServicePlanID"),
                UnitID_internal: sessionStorage.getItem(
                    "unitID_internalSubscriber"
                ),
                StripeClientSecret: sessionStorage.getItem(
                    "stripeClientSecretSubscriber"
                ),
                EmailAddress: sessionStorage.getItem("emailSubscriber"),
                VenueID: sessionStorage.getItem("venueIDSubscriber"),
                "StartDateTimeUTC.ISO8601": new Date(
                    sessionStorage.getItem("dateStart")
                ).toISOString(),
                locale: "en-us",
                BillingCycleRecurrence: BillingCycleRecurrence,
                updatePaymentMethod: true,
            };
        }
        axios
            .post(
                "/networkoperatorconsole/shoppingcart/requestSubscription",
                data,
                {
                    headers: {},
                }
            )
            .then((response) => {
                setClientSecret(response.data.StripeClientSecret);
                sessionStorage.setItem(
                    "clientSecret",
                    response.data.StripeClientSecret
                );
                sessionStorage.setItem(
                    "nextPaymentDate",
                    response.data.NextPaymentDate
                );
                sessionStorage.setItem(
                    "proratedPricePerHour",
                    response.data["ProratedPricePerHour.USD"]
                );
                sessionStorage.setItem(
                    "unbilledHoursTilNextPaymentDate",
                    response.data.UnbilledHoursTillNextPaymentDate
                );
                sessionStorage.setItem(
                    "trialEndDate",
                    response.data.TrialEndDate
                );
                sessionStorage.setItem(
                    "firstInvoiceDate",
                    response.data["FirstInvoiceDateUTC.ISO8601"]
                );
                setStripePromise(response.data.StripePublishableKey);
                setState({ billingDetails: response.data });
            })
            .catch((error) => {
                console.log(
                    "🚀 ~ file: CheckOut.js:98 ~ useEffect ~ error",
                    error
                );
                setState({
                    errorMessage: error.response.data.message,
                });
            });
    }, []);
    function toggleBillingDetails() {
        setState({
            modalBillingDetails: !state.modalBillingDetails,
        });
    }
    function selectedPlan(
        servicePlanKey,
        servicePlanID,
        stripePriceID,
        servicePlanName,
        billingCyclePrice,
        billingCycleRecurrence,
        fixedBillingDate,
        trialCycles
    ) {
        sessionStorage.setItem("servicePlanKey", servicePlanKey);
        sessionStorage.setItem("servicePlanID", servicePlanID);
        sessionStorage.setItem("stripePriceID", stripePriceID);
        sessionStorage.setItem("servicePlanName", servicePlanName);
        sessionStorage.setItem("billingCyclePrice", billingCyclePrice);
        sessionStorage.setItem("servicePlanPriceSubscriber", billingCyclePrice);
        sessionStorage.setItem(
            "billingCycleRecurrence",
            billingCycleRecurrence
        );
        sessionStorage.setItem("fixedBillingDate", fixedBillingDate);
        sessionStorage.setItem("trialCycles", trialCycles);
    }
    function setSessionStorage() {
        const urlParams = new URLSearchParams(window.location.search);
        console.log('Processing URL parameters for session storage...');
        for (const [key, value] of urlParams.entries()) {
            if (key.startsWith('ss_')) {
                // Remove the 'ss_' prefix to get the actual session storage key
                const sessionKey = key.substring(3);
                // Store in session storage
                sessionStorage.setItem(sessionKey, value);
                console.log(`Stored in session storage: ${sessionKey} = ${value}`);
            }
        }
    }
    function returnToDashboard() {
        // Try to get return URL from multiple sources
        const urlParams = new URLSearchParams(window.location.search);
        const returnUrl = urlParams.get('returnUrl') || 
                         sessionStorage.getItem('returnUrl') || 
                         document.referrer;
        const fromApp = sessionStorage.getItem('fromApp') === 'true';
        if (returnUrl && returnUrl !== window.location.href && fromApp) {
            try {
                console.log('🔙 Going back to last app:', returnUrl);
                // Check if it's an app URL scheme
                if (returnUrl.includes('://') && !returnUrl.startsWith('http')) {
                    // It's a custom scheme (like myapp://), try to bring app to foreground
                    bringAppToForeground(returnUrl);
                } else if (returnUrl.startsWith('http')) {
                    // It's a web URL, navigate to it
                    window.location.href = returnUrl;
                } else {
                    // Fallback: go back in history
                    window.history.back();
                }
            } catch (error) {
                console.error('Error going back to last app:', error);
                // Fallback: try browser back
                window.history.back();
            }
        } else {
            // No return URL found or not from app, use browser back or default
            if (window.history.length > 1) {
                window.history.back();
            } else {
                // No history, redirect to a default page
                window.location.href = "/" + success.ui;
            }
        }
    }
    function isMobile() {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }
    function isIOS() {
        return /iPad|iPhone|iPod/.test(navigator.userAgent);
    }
    function isAndroid() {
        return /Android/.test(navigator.userAgent);
    }
    function bringAppToForeground(appUrl) {
        console.log('🔄 Attempting to bring app to foreground:', appUrl);
        if (isMobile()) {
            if (isIOS()) {
                // iOS: Use universal links or URL schemes to bring app to foreground
                bringIOSAppToForeground(appUrl);
            } else if (isAndroid()) {
                // Android: Use intent or custom scheme
                bringAndroidAppToForeground(appUrl);
            } else {
                // Other mobile platforms
                window.location.href = appUrl;
            }
        } else {
            // Desktop: Limited options, try opening the URL
            window.location.href = appUrl;
        }
    }
    function bringIOSAppToForeground(appUrl) {
        // iOS approach: Use URL scheme that brings app to foreground without full restart
        const foregroundUrl = appUrl.includes('?') 
            ? `${appUrl}&action=foreground&timestamp=${Date.now()}`
            : `${appUrl}?action=foreground&timestamp=${Date.now()}`;
        console.log('📱 iOS: Attempting to bring app to foreground with URL:', foregroundUrl);
        // Track if the page becomes hidden (app opened)
        let appOpened = false;
        const handleVisibilityChange = () => {
            if (document.hidden) {
                appOpened = true;
                console.log('✅ iOS: App likely brought to foreground - page hidden');
            }
        };
        document.addEventListener('visibilitychange', handleVisibilityChange);
        // Try to open the app
        window.location.href = foregroundUrl;
        // Clean up after 3 seconds
        setTimeout(() => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
            if (!appOpened) {
                console.log('⚠️ iOS: App may not have opened - page still visible');
            }
        }, 3000);
    }
    function bringAndroidAppToForeground(appUrl) {
        // Android approach: Use intent with FLAG_ACTIVITY_BROUGHT_TO_FRONT
        const foregroundUrl = appUrl.includes('?') 
            ? `${appUrl}&action=bring_to_front&timestamp=${Date.now()}`
            : `${appUrl}?action=bring_to_front&timestamp=${Date.now()}`;
        // Try creating an intent URL that brings the app to foreground
        const intentUrl = `intent://${foregroundUrl.replace('myapp://', '')}#Intent;scheme=myapp;package=com.yourapp.package;action=android.intent.action.VIEW;category=android.intent.category.BROWSABLE;launchFlags=0x10200000;end`;
        try {
            window.location.href = intentUrl;
        } catch (error) {
            console.log('Intent failed, trying direct scheme:', error);
            window.location.href = foregroundUrl;
        }
    }
    function handleBackToLastApp(event){
        event.preventDefault();
        // Try to get return URL from multiple sources
        const urlParams = new URLSearchParams(window.location.search);
        const returnUrl = urlParams.get('returnUrl') || 
                         sessionStorage.getItem('returnUrl') || 
                         document.referrer;
        if (returnUrl && returnUrl !== window.location.href) {
            try {
                console.log('🔙 Going back to last app:', returnUrl);
                // Check if it's an app URL scheme
                if (returnUrl.includes('://') && !returnUrl.startsWith('http')) {
                    // It's a custom scheme (like myapp://), try to bring app to foreground
                    this.bringAppToForeground(returnUrl);
                } else if (returnUrl.startsWith('http')) {
                    // It's a web URL, navigate to it
                    window.location.href = returnUrl;
                } else {
                    // Fallback: go back in history
                    window.history.back();
                }
            } catch (error) {
                console.error('Error going back to last app:', error);
                // Fallback: try browser back
                window.history.back();
            }
        } else {
            // No return URL found, use browser back or default
            if (window.history.length > 1) {
                window.history.back();
            } else {
                // No history, redirect to a default page
                window.location.href = "/" + success.ui;
            }
        }
    }
   function handleReturnToAppWithRedirect(){
        console.log('🔄 Using Expo-style redirect logic');
        var baseUri = 'exp://192.168.1.151:8081';
        // Take the uri from the params
         var linkingUri = sessionStorage.getItem("linkingUri");
            if (linkingUri) {
                baseUri = linkingUri;
            }
        console.log('📱 Base URI for redirect:', baseUri);
        // Update any existing link urls (if needed)
        var links = document.querySelectorAll('a');
        for (var i = 0; i < links.length; ++i) {
            if (links[i].href.includes('exp://REPLACE_ME/')) {
                links[i].href = links[i].href.replace('exp://REPLACE_ME/', baseUri);
                console.log('🔗 Updated link:', links[i].href);
            }
        }
        // Immediate redirect with message
        try {
            const redirectUrl = baseUri + (baseUri.includes('?') ? '&' : '?') + 'message=' + encodeURIComponent('Redirected from payment page');
            console.log('🚀 Redirecting to:', redirectUrl);
            window.location.href = redirectUrl;
        } catch (error) {
            console.error('❌ Expo redirect failed:', error);
            // Fallback to the original method
            this.returnToDashboard();
        }
    }
    return (
        <>
            {state.errorMessage !== undefined ? (
                <div className="overlay" style={{ display: "block" }}>
                    <div className="overlayMessage">
                        {state.errorMessage}
                        <div className="nextButton">
                            <br />
                            <a
                                className="btn Ripple-parent btn-default"
                                href={"/" + success.ui}
                                rel="noreferrer"
                            >
                                Return
                            </a>
                        </div>
                    </div>
                </div>
            ) : (
                ""
            )}
            <Suspense
                fallback={
                    <div
                        className="overlay"
                        id="overlay"
                        style={{ display: "block" }}
                    >
                        <div className="overlayMessage">
                            <div
                                className="spinner-border spinner-border"
                                role="status"
                            >
                                <span className="sr-only">Loading...</span>
                            </div>
                        </div>
                    </div>
                }
            >
                {success.success ? (
                    <MDBModal isOpen={true} centered>
                        <MDBModalBody className="updatePayment">
                            <h2>Congratulations!</h2>
                            <p>Your payment method has been updated.</p>
                                 {(() => {
                                    const urlParams = new URLSearchParams(window.location.search);
                                    const returnUrl = urlParams.get('linkingUri') || sessionStorage.getItem('linkingUri');
                                    const fromApp = sessionStorage.getItem('fromApp') === 'true';
                                    return (returnUrl && fromApp) ? (
                                        <div className="backButton" style={{ marginTop: "20px" }}>
                                            <a
                                                className="btn Ripple-parent btn-primary"
                                                href="#"
                                                onClick={handleReturnToAppWithRedirect}
                                            >
                                                Return to App
                                            </a>
                                        </div>
                                    ) : (
                                        <div className="nextButton">
                            <br />
                            <a
                                className="btn Ripple-parent btn-default"
                                href={"/" + success.ui}
                                rel="noreferrer"
                            >
                                Return
                            </a>
                        </div>
                                    );
                                })()}
                            </MDBModalBody>
                        </MDBModal>
                    ) : (
                    ""
                )}
                <CheckOutComponent
                    stripePromise={stripePromise}
                    clientSecret={clientSecret}
                    logo={props.logoLogin}
                    brand={props.brand}
                    toggleBillingDetails={toggleBillingDetails}
                    modalBillingDetails={state.modalBillingDetails}
                    billingDetails={state.billingDetails}
                />
                <Footer />
            </Suspense>
        </>
    );
}
